/**
 * Pixel-art icons drawn on a 12x12 grid ('#' = filled pixel). Crisp at 1x/2x and themeable via
 * currentColor.
 */
import { memo } from 'react';

const ICONS = {
  mic: [
    '....####....',
    '...#....#...',
    '...#....#...',
    '...#....#...',
    '...#....#...',
    '...#....#...',
    '.#..####..#.',
    '.#........#.',
    '..#......#..',
    '...######...',
    '.....##.....',
    '...######...',
  ],
  micOff: [
    '#...####....',
    '.#.#....#...',
    '..##....#...',
    '...##...#...',
    '...#.#..#...',
    '...#..#.#...',
    '.#..###...#.',
    '.#......#.#.',
    '..#......#..',
    '...######.#.',
    '.....##....#',
    '...######...',
  ],
  headphones: [
    '...######...',
    '..#......#..',
    '.#........#.',
    '#..........#',
    '#..........#',
    '#..........#',
    '###......###',
    '####....####',
    '####....####',
    '####....####',
    '.##......##.',
    '............',
  ],
  headphonesOff: [
    '#..######...',
    '.#.......#..',
    '.##.......#.',
    '#..#.......#',
    '#...#......#',
    '#....#.....#',
    '###...#..###',
    '####...#####',
    '####....####',
    '####....#.##',
    '.##......##.',
    '...........#',
  ],
  gear: [
    '....####....',
    '.##.####.##.',
    '.##########.',
    '..###..###..',
    '####....####',
    '####....####',
    '####....####',
    '####....####',
    '..###..###..',
    '.##########.',
    '.##.####.##.',
    '....####....',
  ],
  door: [
    '#######.....',
    '#.....#.....',
    '#.....#..#..',
    '#.....#..##.',
    '#...#######.',
    '#...########',
    '#...#######.',
    '#.....#..##.',
    '#.....#..#..',
    '#.....#.....',
    '#######.....',
    '............',
  ],
  radio: [
    '............',
    '.#........#.',
    '#..#....#..#',
    '#.#..##..#.#',
    '#.#.####.#.#',
    '#.#..##..#.#',
    '#..#.##.#..#',
    '.#...##...#.',
    '.....##.....',
    '....####....',
    '...######...',
    '............',
  ],
  volume: [
    '.....#......',
    '....##...#..',
    '...###....#.',
    '####.#..#..#',
    '####.#...#.#',
    '####.#...#.#',
    '####.#..#..#',
    '...###....#.',
    '....##...#..',
    '.....#......',
    '............',
    '............',
  ],
  volumeOff: [
    '.....#......',
    '....##......',
    '...###......',
    '####.#.#...#',
    '####.#..#.#.',
    '####.#...#..',
    '####.#..#.#.',
    '...###.#...#',
    '....##......',
    '.....#......',
    '............',
    '............',
  ],
  keyboard: [
    '............',
    '############',
    '#..........#',
    '#.#.#.#.#..#',
    '#..........#',
    '#.#.#.#.#..#',
    '#..........#',
    '#..######..#',
    '#..........#',
    '############',
    '............',
    '............',
  ],
  back: [
    '............',
    '....#.......',
    '...##.......',
    '..###.......',
    '.##########.',
    '###########.',
    '.##########.',
    '..###.......',
    '...##.......',
    '....#.......',
    '............',
    '............',
  ],
  check: [
    '............',
    '..........##',
    '.........##.',
    '........##..',
    '.......##...',
    '##....##....',
    '.##..##.....',
    '..####......',
    '...##.......',
    '............',
    '............',
    '............',
  ],
  warn: [
    '.....##.....',
    '....####....',
    '....#..#....',
    '...##..##...',
    '...#.##.#...',
    '..##.##.##..',
    '..#..##..#..',
    '.##......##.',
    '.#...##...#.',
    '##...##...##',
    '############',
    '............',
  ],
  info: [
    '...######...',
    '..#......#..',
    '.#...##...#.',
    '#....##....#',
    '#..........#',
    '#...###....#',
    '#....##....#',
    '#....##....#',
    '.#..####..#.',
    '..#......#..',
    '...######...',
    '............',
  ],
  users: [
    '...##.......',
    '..####..##..',
    '..####.####.',
    '...##..####.',
    '........##..',
    '.######.....',
    '########.##.',
    '########.###',
    '########.###',
    '.......#####',
    '............',
    '............',
  ],
  prox: [
    '............',
    '....####....',
    '..##....##..',
    '.#........#.',
    '.#...##...#.',
    '#...####...#',
    '#...####...#',
    '.#...##...#.',
    '.#........#.',
    '..##....##..',
    '....####....',
    '............',
  ],
  store: [
    '....####....',
    '...#....#...',
    '...#....#...',
    '.##########.',
    '.##########.',
    '.##.####.##.',
    '.##########.',
    '.##########.',
    '.##########.',
    '.##########.',
    '.##########.',
    '............',
  ],
  /** collegamento diretto (UDP verso il server voce): fulmine */
  netDirect: [
    '......####..',
    '.....####...',
    '....####....',
    '...####.....',
    '..########..',
    '.########...',
    '.....###....',
    '....###.....',
    '...###......',
    '..##........',
    '.#..........',
    '............',
  ],
  /** collegamento tramite relay (TURN o TCP): pila di server */
  netRelay: [
    '.##########.',
    '.#........#.',
    '.#.##..#..#.',
    '.#........#.',
    '.##########.',
    '.#........#.',
    '.#.##..#..#.',
    '.#........#.',
    '.##########.',
    '.....##.....',
    '...######...',
    '............',
  ],
  close: [
    '............',
    '.##......##.',
    '..##....##..',
    '...##..##...',
    '....####....',
    '.....##.....',
    '....####....',
    '...##..##...',
    '..##....##..',
    '.##......##.',
    '............',
    '............',
  ],
} as const;

export type IconName = keyof typeof ICONS;

const PATHS: Record<string, string> = {};
function pathFor(name: IconName): string {
  if (PATHS[name]) return PATHS[name]!;
  let d = '';
  ICONS[name].forEach((row, y) => {
    let x = 0;
    while (x < row.length) {
      if (row[x] === '#') {
        let w = 1;
        while (row[x + w] === '#') w++;
        d += `M${x} ${y}h${w}v1h-${w}z`;
        x += w;
      } else x++;
    }
  });
  PATHS[name] = d;
  return d;
}

export const Icon = memo(function Icon({ name, size = 18, title }: { name: IconName; size?: number; title?: string }) {
  // L'ingranaggio delle impostazioni è un'immagine pixel-art a colori (non una maschera currentColor).
  if (name === 'gear') {
    return (
      <img
        className="icon icon-gear"
        src="/brand/gear.png"
        width={size}
        height={size}
        alt={title ?? ''}
        aria-hidden={title ? undefined : true}
        draggable={false}
      />
    );
  }
  return (
    <svg
      className="icon"
      width={size}
      height={size}
      viewBox="0 0 12 12"
      shapeRendering="crispEdges"
      aria-hidden={title ? undefined : true}
      role={title ? 'img' : undefined}
    >
      {title ? <title>{title}</title> : null}
      <path d={pathFor(name)} fill="currentColor" />
    </svg>
  );
});
